import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Outlet } from 'react-router';
import { APP_NAME } from '@/constants';
import { useLogout } from '@/features/auth';
import { useEnvironmentStore } from '@/stores/environment';
import { Button } from '@/components/ui/Button';
// Color-code the env badge so the target environment is unmistakable at a glance.
const ENV_BADGE_CLASSES = {
    dev: 'bg-green-100 text-green-800',
    stg: 'bg-amber-100 text-amber-900',
    prod: 'bg-red-100 text-red-800',
};
// Stub shell for the authenticated admin area. Grows a real nav in later phases.
export function AdminLayout() {
    const logout = useLogout();
    // Show the environment the operator chose to explore at login, not the
    // build-time deployment env — they can target a different backend at runtime.
    const env = useEnvironmentStore((s) => s.env);
    return (_jsxs("div", { className: "min-h-screen bg-surface", children: [_jsxs("header", { className: "h-14 border-b border-outline-variant flex items-center justify-between px-6", children: [_jsxs("div", { className: "flex items-center gap-3", children: [_jsxs("span", { className: `rounded px-2 py-1 text-base font-extrabold uppercase tracking-wide ${ENV_BADGE_CLASSES[env]}`, children: ["ENV: ", env] }), _jsx("span", { className: "text-[15px] font-semibold text-on-surface", children: APP_NAME })] }), _jsx(Button, { variant: "ghost", className: "h-9 px-3 text-[14px]", onClick: () => void logout(), children: "Sign out" })] }), _jsx("main", { className: "mx-auto max-w-[1280px] px-6 pt-6 pb-8", children: _jsx(Outlet, {}) })] }));
}
